import { render } from "./CorporateEvents.vue?vue&type=template&id=bb3a4306"
import script from "./CorporateEvents.vue?vue&type=script&lang=js"
export * from "./CorporateEvents.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__